import * as React from 'react'
import styled from 'styled-components'
import { AppBar } from './AppBar'
import { useApi } from 'src/api'
import { observer } from 'mobx-react-lite'
import { RouteState } from 'src/constants/routes'
import { hot } from 'react-hot-loader/root'

const Wrapper = styled.section`
  width: 100%;
  height: calc(100% - 64px);
  top: 64px;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  position: absolute;
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
`

const StyledLayout = styled.section`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  * {
    font-family: Roboto, sans-serif;
    font-style: normal;
  }
`
export const Layout: React.FC<{ routeState: RouteState }> = hot(
  observer(({ children, ...props }) => {
    const routeState = useApi((store) => store.routeState)
    return (
      <StyledLayout>
        <AppBar {...{ routeState, ...props }} />
        <Wrapper>{children}</Wrapper>
      </StyledLayout>
    )
  })
)

// const setupPage = {
//   primary: '#3F7A5B',
//   secondary: '#90BCA4'
// }

// const viewerColors = {
//   printedcircuitboard: {
//     properties: '#407A5B',
//     'properties.componentSide': '#468765',
//     'properties.soldierSide': '#468765'
//   },
//   contentEdge: {
//     'properties.gap': '#408487'
//   },
//   adapterPlate: {
//     properties: '#B58D21'
//   },
//   bracket: {
//     properties: ''
//   },
//   cover: {
//     color: {
//       green: '#449152',
//       red: '#D33D53',
//       blue: '#3F68E9',
//       orange: '#FE8000',
//       yellow: '#FFE83F',
//       black: 'rgba(0,0,0,1)',
//       white: 'rgba(255,255,255,1)',
//       transparent: 'rgba(255,255,255,0.2)'
//     }
//   }
// }
